import CommonMixin from './CommonMixin'
import DetailLayout from './DetailLayout'
import DetailField from './DetailField'

export default {
  name: 'DetailMixin',
  mixins: [CommonMixin],
  components: {
    DetailLayout,
    DetailField
  },
  computed: {
    isReadOnly () { return !this.isEdit && !this.isNew },
    isEdit () { return this.$route.query.mode === 'edit' },
    isNew () { return this.$route.params.id === 'new' }
  },
  // props: {
  // },
  data () {
    return {
      dataValid: false
    }
  },
  // watch: {
  // },
  methods: {
    setDataValid () {
      this.dataValid = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/DetailMixin.js